<template>
  <div class="ticket-actions">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-xs-12">
            <h4 class="card-title">
              <i class="ti-angle-double-right"></i> Ações</h4>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-xs-12" v-if="$can('tickets.checkin')">
            <ticket-check-in :ticket="ticket"/>
          </div>
          <div class="col-xs-12" v-if="$can('tickets.uploadDoc')">
            <tickets-documentation/>
          </div>
          <div class="col-xs-12" v-if="$can('tickets.uploadImg')">
            <tickets-upload-images/>
          </div>
          <div class="col-xs-12" v-if="$can('tickets.downloadDoc')">
            <ticket-download-documents/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TicketCheckIn from './Actions/TicketCheckIn'
  import TicketDownloadDocuments from './Actions/TicketDownloadDocuments'
  import TicketsDocumentation from './Actions/TicketsDocumentation'
  import TicketsUploadImages from './Actions/TicketsUploadImages'
  import {mapGetters} from 'vuex'

  export default {
    name: 'ticket-actions',
    components: {
      TicketsDocumentation,
      TicketCheckIn,
      TicketDownloadDocuments,
      TicketsUploadImages
    },
    computed: {
      ...mapGetters('tickets', ['ticket'])
    }
  }
</script>

<style scoped>
  .col-xs-12 {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Tickets/TicketActions.vue